/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientSocialHabitsApi } from '../api/patientsocialhabits.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientSocialHabits,PatientSocialHabitsData} from '../../../interfaces/masters/patientSocialHabits';

@Injectable()
export class PatientSocialHabitsService extends PatientSocialHabitsData {

  constructor(private api: PatientSocialHabitsApi) {
    super();
  }


  list(url: string): Observable<PatientSocialHabits[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<PatientSocialHabits> {
    return this.api.getById(url);
  }

  create(url: string, data: PatientSocialHabits): Observable<PatientSocialHabits> {
    return this.api.add(url, data);
  }

  update(url: string, data: PatientSocialHabits): Observable<PatientSocialHabits> {
    return this.api.update(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
